import WeekByWeekImages from '../images/WeekByWeekImages';

const trimesterValues = [
  {
    title: 'First Trimester',
    image: WeekByWeekImages.weekByWeek.trimester1,
    paragraph:
      "Congratulations on your pregnancy, mama! Your body is about to go through a number of serious changes during the first trimester. Week-to-week pregrancy symptoms can be different for every expecting mom, but things like exhaustion and morning sickness are pretty common. here's what else you can expect during the early stages of pregnancy.",
    weeks: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  },
  {
    title: 'Second Trimester',
    image: WeekByWeekImages.weekByWeek.trimester2,
    paragraph:
      "Welcome to the honeymoon phase of pregnancy! By second trimester, some symptoms are fading and you may even notice a baby bump starting to show, but growing a tiny human is still hard work. Here's what you can expect during the second trimester and your pregnancy week-by-week glance.",
    weeks: [14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27],
  },
  {
    title: 'Third Trimester',
    image: WeekByWeekImages.weekByWeek.trimester3,
    paragraph:
      "You're in the home stretch and the countdown is on, mama! The third trimester is when expecting moms experience a wide variety of emotion about finally meeting their baby. As your body prepares for delivery, learn what's normal - or not- during these final weeks of your pregnancy.",
    weeks: [28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42],
  },
];

export default trimesterValues;
